import axiosInstance from "@/api/axios";

export const addAllLeadsToCRM = async (leadIds: number[]) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/projectLeads/saveMultipleLeads",
      data: {
        leadIds: leadIds, // Pass the array of lead IDs in the request body
      },
    });
    console.log("response", response);
    return {
      response: response.data.data,
      leadIds: leadIds,
    };
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const fetchSortingOptions = async () => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/projectLeads/sortingOptions",
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const exportLeads = async (
  exportType: string,
  selectedLeadIds: Array<number>,
  exportKeys: Array<string>
) => {
  try {
    //  console.log(exportType,selectedLeadIds,exportKeys,"line 39")
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/export",
      data: {
        exportType,
        leadIds: selectedLeadIds,
        exportKeys: exportKeys,
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const exportProjectLeads = async (
  exportType: string,
  selectedLeadIds: Array<number>,
  exportKeys: Array<string>
) => {
  try {
    console.log(exportType, selectedLeadIds, exportKeys, "----line 38");
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/projectLeads/export",
      data: {
        exportType,
        leadIds: selectedLeadIds,
        exportKeys: exportKeys,
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const fetchFilterOptions = async (params: object) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/projectLeads/filters/v2",
      params: params,
    });
    return response.data;
  } catch (err) {
    console.log(err, "error");
  }
};

export const addToWatchList = async (builder_id: number) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/builders/watchlist/add",
      data: {
        builder_id: builder_id, // Pass the array of lead IDs in the request body
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const removeFromWatchList = async (builder_id: number) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/builders/watchlist/remove",
      data: {
        builder_id: builder_id, // Pass the array of lead IDs in the request body
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};
